import { render, staticRenderFns } from "./AddSearchFields.vue?vue&type=template&id=8238c798&"
import script from "./AddSearchFields.vue?vue&type=script&lang=js&"
export * from "./AddSearchFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports